import React, { useEffect, useRef, useState } from 'react';
import SVG from './SVG.jsx';
import Rimg from './Rimg.jsx';

function YesOrNo(props) {
  return (
    <fieldset className="form-field">
      <legend className="form-legend">{props.label}</legend>
      <div className="option-values option-values-one-line">
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`yesOrNo-0`}
            name="yesOrNo"
            value={true}
            checked={props.getValue === true}
            onChange={() => props.setValue(true)} />
          <label htmlFor={`yesOrNo-0`} className="option-value-name">Yes</label>
        </div>
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`yesOrNo-1`}
            name="yesOrNo"
            value={false}
            checked={props.getValue === false}
            onChange={() => props.setValue(false)} />
          <label htmlFor={`yesOrNo-1`} className="option-value-name">No</label>
        </div>
      </div>
    </fieldset>
  );
}

function Size1(props) {
  const { getSize, setSize, location, label, sizes, isWomens, isSneaker } = props;
  const ref = useRef(null);

  let useSmallerSize = true;
  if (location.code === 'eu' && (isWomens || isSneaker)) {
    useSmallerSize = false;
  }

  useEffect(() => {
    if (ref.current) {
      if (!getSize.us) {
        ref.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <fieldset className="form-field" ref={ref}>
      <legend className="form-legend">{label}</legend>
      <div className="option-values">
        {sizes
          .map(function (size, index) {
            if (!size.presented || this.includes(size[location.code]) === useSmallerSize) {
              this.push(size[location.code])
              return (null);
            }
            this.push(size[location.code])
            return (
              <div key={index} className="option-value">
                <input
                  type="radio"
                  className="option-value-input"
                  id={`sneakerSize-${index}`}
                  name="sneakerSize"
                  value={size.us}
                  checked={getSize.us === size.us}
                  onChange={() => setSize(size)} />
                <label htmlFor={`sneakerSize-${index}`} className="option-value-name">{size[location.code]}</label>
              </div>
            )
          }, [])
        }
      </div>
    </fieldset>
  );
}

function Size2(props) {
  const { getSize2, setSize2, getSize1, label, location, sizes, isWomens, isSneaker } = props;

  let previousDelta = 1;
  let nextDelta = 1;

  if (location.code === 'eu') {
    if (isWomens || isSneaker) {
      previousDelta = 2;
    } else {
      nextDelta = 2;
    }
  }

  const sizeIndex = sizes.findIndex(s => s.us === getSize1.us);
  let previousSize = sizes[sizeIndex - previousDelta];
  let nextSize = sizes[sizeIndex + nextDelta];
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      if (!getSize2.us) {
        ref.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <fieldset className="form-field" ref={ref}>
      <legend className="form-legend">{label}</legend>
      <div className="option-values option-values-one-per-line">
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`size2-0`}
            name="size2"
            value={previousSize.us}
            checked={getSize2.us === previousSize.us}
            onChange={() => setSize2(previousSize)} />
          <label htmlFor={`size2-0`} className="option-value-name">I sometimes wear size {previousSize[props.location.code]}</label>
        </div>
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`size2-1`}
            name="size2"
            value={getSize1.us}
            checked={getSize2.us === getSize1.us}
            onChange={() => setSize2(getSize1)} />
          <label htmlFor={`size2-1`} className="option-value-name">I always wear size {getSize1[props.location.code]}</label>
        </div>
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`size2-2`}
            name="size2"
            value={nextSize.us}
            checked={getSize2.us === nextSize.us}
            onChange={() => props.setSize2(nextSize)} />
          <label htmlFor={`size2-2`} className="option-value-name">I sometimes wear size {nextSize[props.location.code]}</label>
        </div>
      </div>
    </fieldset>
  );
}

function Step1(props) {
  const { locations, standards, getStandard, setStandard, getLocation, setLocation } = props;

  return (
    <div className="form-body">
      <fieldset className="form-field">
        <legend className="form-legend">Select your size standard.</legend>
        <div className="option-values option-values-one-line">
          {standards
            .map((standard, index) => {
              return (
                <div key={index} className="option-value">
                  <input
                    type="radio"
                    className="option-value-input"
                    id={`standard-${index}`}
                    name="standard"
                    value={standard.code}
                    checked={getStandard.code === standard.code}
                    onChange={() => setStandard(standard)} />
                  <label htmlFor={`standard-${index}`} className="option-value-name">{standard.label}</label>
                </div>
              )
            })
          }
        </div>
      </fieldset>
      <fieldset className="form-field">
        <legend className="form-legend">Select your location.</legend>
        <div className="option-values option-values-one-line">
          {locations
            .map((country, index) => {
              return (
                <div key={index} className="option-value">
                  <input
                    type="radio"
                    className="option-value-input"
                    id={`location-${index}`}
                    name="location"
                    value={country.code}
                    checked={getLocation.code === country.code}
                    onChange={() =>
                      setLocation(country)
                    } />
                  <label htmlFor={`location-${index}`} className="option-value-name">{country.label}</label>
                </div>
              )
            })
          }
        </div>
      </fieldset>
      <p className="ff-intro">Before we get started, we need to know what sizes to show you! Selecting your gender and country allows us to pair you with the right size standard. For example, if you select "Men's" and "US", we'll show you sizes in the US Men's size standard.</p>
      <p className="ff-intro">For more information on our sizes, click <a href="#" onClick={(e) => { props.closeFitFinder(); props._openSizeGuide(e); }}>here</a>.</p>
    </div>
  );
}

function Step2(props) {
  const { sizes, getStandard, getLocation, getSneakerSize, getSneakerSize2, setSneakerSize, setSneakerSize2, isWomens, isSneaker } = props;

  return (
    <div className="form-body">
      <Size1 location={getLocation} getSize={getSneakerSize} setSize={setSneakerSize} sizes={sizes[getStandard.code]} isWomens={isWomens} isSneaker={isSneaker} label="What is your sneaker size?" />
      {getSneakerSize.us && <Size2 location={getLocation} getSize1={getSneakerSize} getSize2={getSneakerSize2} setSize2={setSneakerSize2} sizes={sizes[getStandard.code]} isWomens={isWomens} isSneaker={isSneaker} label="Do you ever wear other sizes in sneakers?" />}
    </div>
  )
}

function Step3(props) {
  const { sizes, getStandard, getLocation, getHasBootSize, setHasBootSize, getBootSize, setBootSize, getBootSize2, setBootSize2, isWomens, isSneaker } = props;

  let label = 'Do you own any Goodyear welted boots or dress shoes?';
  if (props.product.vendor.includes('Women')) {
    label = 'Do you own any leather boots?';

    if (props.product.tags.includes('goodyear-welt')) {
      label = 'Do you own any Goodyear welted leather boots?';
    }
  }

  let label2 = "Do you ever wear other sizes in Goodyear welted footwear?";
  if (props.product.vendor.includes('Women') && !props.product.tags.includes('goodyear-welt')) {
    label2 = "Do you ever wear other sizes in leather boots or shoes?";
  }

  return (
    <div className="form-body">
      <YesOrNo setValue={setHasBootSize} getValue={getHasBootSize} label={label} />
      {getHasBootSize && <Size1 location={getLocation} getSize={getBootSize} setSize={setBootSize} sizes={sizes[getStandard.code]} isWomens={isWomens} isSneaker={isSneaker} label="What size do you wear?" />}
      {getBootSize.us && <Size2 location={getLocation} getSize1={getBootSize} getSize2={getBootSize2} setSize2={setBootSize2} sizes={sizes[getStandard.code]} isWomens={isWomens} isSneaker={isSneaker} label={label2} />}
    </div>
  )
}

function Step4(props) {
  const { widths, getStandard, getHasWidth, setHasWidth, getWidth, setWidth } = props;
  const label = "Do you ever buy narrow or wide width footwear?";

  return (
    <div className="form-body">
      <YesOrNo setValue={setHasWidth} getValue={getHasWidth} label={label} />
      {getHasWidth &&
        <fieldset className="form-field">
          <legend className="form-legend">What width do you wear?</legend>
          <div className="option-values option-values-one-line">
            {widths[getStandard.code]
              .map((width, index) => {
                return (
                  <div key={index} className="option-value">
                    <input
                      type="radio"
                      className="option-value-input"
                      id={`width-${index}`}
                      name="width"
                      value={width}
                      checked={getWidth === width}
                      onChange={() => setWidth(width)} />
                    <label htmlFor={`width-${index}`} className="option-value-name">{width}</label>
                  </div>
                )
              })
            }
          </div>
        </fieldset>}
    </div>
  )
}

function Result(props) {
  const { product, recommendedSize, hasWideWidth, recommendedWidth, recommendedVariant, setRecommendedVariant } = props;
  let image = null;
  const imageIndex = Math.min(2, product.media.length) - 1;
  if (~imageIndex) {
    image = product.media[imageIndex].preview_image;
  }

  useEffect(() => {
    const findVariant = (size) => {
      return product.variants.find(v => {
        if (hasWideWidth) {
          return v.options.includes(recommendedWidth) && v.options.includes(`${size}`)
        }
        return v.options.includes(`${size}`)
      })
    }

    let tempVariant = findVariant(recommendedSize);

    if (!tempVariant) {
      const adjustments = [-0.5, 0.5, -1, 1];
      for (let i = 0; i < adjustments.length; i++) {
        const size = parseFloat(recommendedSize) + adjustments[i];
        tempVariant = findVariant(size);
        if (tempVariant) {
          break;
        }
      }
    }

    if (tempVariant) {
      setRecommendedVariant(tempVariant);
    }
  }, [recommendedWidth, recommendedSize])

  const RecommendationBody = () => {
    if (recommendedSize) {
      if (recommendedVariant.id) {
        if (recommendedVariant.available) {
          return (
            <React.Fragment>
              <p className="text1">We recommend you order a size</p>
              <h1 className="recommended-size">{recommendedVariant.title}</h1>
              <p className="text2">in the {product.title}</p>
            </React.Fragment>
          )
        } else {
          return (
            <p className="text1">Your size is popular! We recommend you order a size {recommendedVariant.title} in this style, but {product.tags.includes('BIS') ? `that size is currently out of stock. Join the waitlist below and we'll send you an email as soon as we've restocked your size.` : `no longer stock this style in your size. If you're dying to have one, feel free to contact us and we'll see if there's anything we can do to help!`}</p>
          )
        }
      } else {
        return (
          <p className="text1">Looks like we don't carry this style in your size! We would normally recommend you order a size {recommendedWidth ? `${recommendedWidth} ${recommendedSize}` : recommendedSize}. Feel free to try the nearest available size. If it doesn't fit, send it back for free (contiguous US).</p>
        )
      }
    } else {
      return (
        <p className="text1">We aren't able to recommend a size at this time. Please contact us for help.</p>
      )
    }
  }

  return (
    <div className="form-body">
      {image && <Rimg src={image.src} width={image.width} height={image.height} loading="lazy" className="ff-image" />}
      <RecommendationBody />
      <p className="ff-tooltip">Prefer a second opinion? <a href="/pages/email-us">Send us an email!</a></p>
    </div>
  )
}

function _addToCart(props) {
  const { recommendedVariant, _optionChanged, closeFitFinder, handle, vendor } = props;
  if (Object.keys(recommendedVariant).length > 0) {
    recommendedVariant.options.forEach((option, index) => {
      _optionChanged(`option${index + 1}`, option)
    })
  }

  closeFitFinder();

  if (recommendedVariant.available) {
    window.heap && window.heap.track('Added To Cart', {vendor: vendor, handle: handle, sku: recommendedVariant.sku });
    const fitFinderAddEvent = new CustomEvent('fitFinder:add', { detail: { fitFinder: true } });
    setTimeout(() => { window.dispatchEvent(fitFinderAddEvent) }, 300);
  } else {
    const fitFinderAddEvent = new CustomEvent('fitFinder:waitlist', { detail: { fitFinder: true } });
    window.dispatchEvent(fitFinderAddEvent);
  }
}

function AddToCartButton(props) {
  const { recommendedVariant, product, _optionChanged, closeFitFinder } = props;
  if (recommendedVariant && (recommendedVariant.available || product.tags.includes('BIS'))) {
    return (
      <button className="form-footer-button action-button" type="button" onClick={() => _addToCart({ recommendedVariant, _optionChanged, closeFitFinder, handle: product.handle, vendor: product.vendor })}>
        {recommendedVariant.available ? 'Add to Cart' : 'Join Waitlist'}
      </button>
    )
  }
  return (null);
}

export default function FitFinderForm(props) {
  const screenCount = (props.product.type === 'Sneakers' ? 3 : 4);
  const standards = [{ label: `Men's`, code: 'mens' }, { label: `Women's`, code: 'womens' }];
  const geoCountryCode = window.localStorage && window.localStorage.getItem('geoip_country_code');
  const locations = [{ label: 'US', regions: ['US', 'CA'], code: 'us' }, { label: 'UK', regions: ['GB', 'IE', 'ZA'], code: 'uk' }, { label: 'EU', regions: ['EU'], code: 'eu' }];
  const sizes = {
    mens: [
      {
        us: 5.5,
        uk: 5,
        eu: 38,
        store: 6,
        presented: false,
      },
      {
        us: 6,
        uk: 5.5,
        eu: 39,
        store: 6,
        presented: true,
      },
      {
        us: 6.5,
        uk: 6,
        eu: 39,
        store: 6.5,
        presented: true,
      },
      {
        us: 7,
        uk: 6.5,
        eu: 40,
        store: 7,
        presented: true,
      },
      {
        us: 7.5,
        uk: 7,
        eu: 40,
        store: 7.5,
        presented: true,
      },
      {
        us: 8,
        uk: 7.5,
        eu: 41,
        store: 8,
        presented: true,
      },
      {
        us: 8.5,
        uk: 8,
        eu: 41,
        store: 8.5,
        presented: true,
      },
      {
        us: 9,
        uk: 8.5,
        eu: 42,
        store: 9,
        presented: true,
      },
      {
        us: 9.5,
        uk: 9,
        eu: 42,
        store: 9.5,
        presented: true,
      },
      {
        us: 10,
        uk: 9.5,
        eu: 43,
        store: 10,
        presented: true,
      },
      {
        us: 10.5,
        uk: 10,
        eu: 43,
        store: 10.5,
        presented: true,
      },
      {
        us: 11,
        uk: 10.5,
        eu: 44,
        store: 11,
        presented: true,
      },
      {
        us: 11.5,
        uk: 11,
        eu: 44,
        store: 11.5,
        presented: true,
      },
      {
        us: 12,
        uk: 11.5,
        eu: 45,
        store: 12,
        presented: true,
      },
      {
        us: 12.5,
        uk: 12,
        eu: 45,
        store: 12.5,
        presented: true,
      },
      {
        us: 13,
        uk: 12.5,
        eu: 46,
        store: 13,
        presented: true,
      },
      {
        us: 13.5,
        uk: 13,
        eu: 46,
        store: 13.5,
        presented: true,
      },
      {
        us: 14,
        uk: 13.5,
        eu: 47,
        store: 14,
        presented: true,
      },
      {
        us: 14.5,
        uk: 14,
        eu: 47,
        store: 14.5,
        presented: true,
      },
      {
        us: 15,
        uk: 14.5,
        eu: 48,
        store: 15,
        presented: true,
      },
      {
        us: 15.5,
        uk: 15,
        eu: 48,
        store: 15.5,
        presented: true,
      },
      {
        us: 16,
        uk: 15.5,
        eu: 49,
        store: 16,
        presented: true,
      },
      {
        us: 16.5,
        uk: 16,
        eu: 49,
        store: 16,
        presented: false,
      },
      {
        us: 17,
        uk: 16.5,
        eu: 50,
        store: 16,
        presented: false,
      },
    ],
    womens: [
      {
        us: 3.5,
        uk: 1.5,
        eu: 34,
        store: 4,
        presented: false,
      },
      {
        us: 4,
        uk: 2,
        eu: 35,
        store: 4,
        presented: true,
      },
      {
        us: 4.5,
        uk: 2.5,
        eu: 35,
        store: 4.5,
        presented: true,
      },
      {
        us: 5,
        uk: 3,
        eu: 36,
        store: 5,
        presented: true,
      },
      {
        us: 5.5,
        uk: 3.5,
        eu: 36,
        store: 5.5,
        presented: true,
      },
      {
        us: 6,
        uk: 4,
        eu: 37,
        store: 6,
        presented: true,
      },
      {
        us: 6.5,
        uk: 4.5,
        eu: 37,
        store: 6.5,
        presented: true,
      },
      {
        us: 7,
        uk: 5,
        eu: 38,
        store: 7,
        presented: true,
      },
      {
        us: 7.5,
        uk: 5.5,
        eu: 38,
        store: 7.5,
        presented: true,
      },
      {
        us: 8,
        uk: 6,
        eu: 39,
        store: 8,
        presented: true
      },
      {
        us: 8.5,
        uk: 6.5,
        eu: 39,
        store: 8.5,
        presented: true
      },
      {
        us: 9,
        uk: 7,
        eu: 40,
        store: 9,
        presented: true
      },
      {
        us: 9.5,
        uk: 7.5,
        eu: 40,
        store: 9.5,
        presented: true
      },
      {
        us: 10,
        uk: 8,
        eu: 41,
        store: 10,
        presented: true
      },
      {
        us: 10.5,
        uk: 8.5,
        eu: 41,
        store: 10.5,
        presented: true
      },
      {
        us: 11,
        uk: 9,
        eu: 42,
        store: 11,
        presented: true
      },
      {
        us: 11.5,
        uk: 9.5,
        eu: 42,
        store: 11.5,
        presented: true
      },
      {
        us: 12,
        uk: 10,
        eu: 43,
        store: 12,
        presented: true
      },
      {
        us: 12.5,
        uk: 10.5,
        eu: 43,
        store: 12,
        presented: false
      },
      {
        us: 13,
        uk: 11,
        eu: 44,
        store: 12,
        presented: false
      },
    ]
  }

  const widths = {
    mens: ['B', 'C', 'D', 'E', 'EE', 'EEE'],
    womens: ['Narrow', 'Wide'],
  }

  if (geoCountryCode) {
    if (geoCountryCode !== 'US') {
      locations[0].label = 'US/CA';
    }
    let exactMatch = 'eu';
    for (const location of locations) {
      if (location.regions.includes(geoCountryCode)) {
        exactMatch = location.code;
        break;
      }
    }
    locations.sort(a => {
      if (exactMatch === a.code) {
        return -1;
      }
      return 1;
    })
  }

  const isWomens = props.product.vendor.includes('Women');
  const isSneaker = props.product.type === 'Sneakers';
  const widthOption = props.product.options_with_values.find(o => o.name === 'Width');
  const hasWideWidth = Boolean(widthOption && widthOption.values.includes('Wide'));

  if (isWomens) {
    standards.reverse();
  }

  let hasBootSize = null;
  if (isSneaker) {
    hasBootSize = false;
  };

  const [step, setStep] = useState(1);
  const [getLocation, setLocation] = useState(locations[0]);
  const [getStandard, setStandard] = useState(standards[0]);
  const [getSneakerSize, setSneakerSize] = useState({});
  const [getSneakerSize2, setSneakerSize2] = useState({});
  const [getHasBootSize, setHasBootSize] = useState(hasBootSize);
  const [getBootSize, setBootSize] = useState({});
  const [getBootSize2, setBootSize2] = useState({});
  const [getHasWidth, setHasWidth] = useState(null);
  const [getWidth, setWidth] = useState(null);
  const [recommendedSize, setRecommendedSize] = useState(null);
  const [recommendedWidth, setRecommendedWidth] = useState(null);
  const [recommendedVariant, setRecommendedVariant] = useState({});
  const [validForm, setValidForm] = useState(false);

  useEffect(() => {
    setSneakerSize2({});
  }, [getSneakerSize.us]);

  useEffect(() => {
    setWidth(null);
  }, [getHasWidth]);

  useEffect(() => {
    setBootSize({});
  }, [getHasBootSize]);

  useEffect(() => {
    setBootSize2({});
  }, [getBootSize.us]);

  useEffect(() => {
    advanceForm();
  }, [getSneakerSize2.us, getHasBootSize, getBootSize2, getHasWidth, getWidth]);

  useEffect(() => {
    if (validateForm()) {
      setValidForm(true);
    } else {
      setValidForm(false);
    }
  })

  const validateForm = () => {
    if (step === 1) {
      return Boolean(getLocation.code && getStandard.code)
    }
    if (step === 2) {
      return Boolean(getSneakerSize.us && getSneakerSize2.us)
    }
    if (step === 3) {
      return Boolean(getHasBootSize === false || getHasBootSize && getBootSize.us && getBootSize2.us)
    }
    if (step === 4) {
      return Boolean(getHasWidth === false || getHasWidth && getWidth)
    }
  }

  const advanceToStep2 = () => {
    if (validateForm()) {
      setStep(2);
      window.heap && window.heap.track('Completed Question 1', { handle: props.product.handle, vendor: props.product.vendor, sizeStandard: `${getStandard.label} ${getLocation.code.toUpperCase()}` });
    }
  }

  const advanceForm = () => {
    if (validateForm()) {
      if (step === 2) {
        window.heap && window.heap.track('Completed Question 2', { handle: props.product.handle, vendor: props.product.vendor, primarySize: getSneakerSize.us, secondarySize: getSneakerSize2.us });
        if (isSneaker) {
          return setStep(4);
        } else {
          return setStep(3);
        }
      } else if (step === 3) {
        window.heap && window.heap.track('Completed Question 3', { handle: props.product.handle, vendor: props.product.vendor, primarySize: getBootSize.us, secondarySize: getBootSize2.us, gywTrue: getHasBootSize });
        return setStep(4);
      } else if (step === 4) {
        window.heap && window.heap.track('Completed Question 4', { handle: props.product.handle, vendor: props.product.vendor, widthTrue: getHasWidth, width: getWidth });
        computeResult();
        return setStep(5);
      }
    }
  }

  const goBack = () => {
    if (step === 4) {
      if (isSneaker) {
        return setStep(2);
      } else {
        return setStep(3);
      }
    }
    if (step === 3) {
      return setStep(2);
    }
    if (step === 2) {
      return setStep(1);
    }
  }

  const resetForm = () => {
    setStep(1);
    setSneakerSize({});
    setSneakerSize2({});
    setHasBootSize(hasBootSize);
    setBootSize({});
    setBootSize2({});
    setHasWidth(null);
    setWidth(null);
    setRecommendedSize(null);
    setRecommendedWidth(null);
  }

  const computeResult = () => {
    const fullDown = props.product.tags.includes('fqv2:full-down');
    const halfDown = props.product.tags.includes('fqv2:half-down');
    const ttsSmaller = props.product.tags.includes('fqv2:tts-down');
    const ttsLarger = props.product.tags.includes('fqv2:tts-up');
    const halfUp = props.product.tags.includes('fqv2:half-up');
    const fullUp = props.product.tags.includes('fqv2:full-up');
    let result = 0;
    if (getHasBootSize === false) {
      if (getSneakerSize2.us && getSneakerSize2.us !== getSneakerSize.us) {
        result = getSneakerSize2.us;
        const smaller = Math.min(getSneakerSize.us, getSneakerSize2.us);
        const larger = Math.max(getSneakerSize.us, getSneakerSize2.us);
        if (fullDown) {
          result = smaller - 0.5;
        } else if (halfDown || ttsSmaller) {
          result = smaller;
        } else if (halfUp || ttsLarger) {
          result = larger;
        } else if (fullUp) {
          result = larger + 0.5;
        }
      } else {
        result = getSneakerSize.us;
        if (fullDown) {
          result = getSneakerSize.us - 1;
        } else if (halfDown) {
          result = getSneakerSize.us - 0.5;
        } else if (ttsLarger || ttsSmaller) {
          result = getSneakerSize.us;
        } else if (halfUp) {
          result = getSneakerSize.us + 0.5;
        } else if (fullUp) {
          result = getSneakerSize.us + 1;
        }
      }
    } else {
      if (getBootSize2.us && getBootSize2.us !== getBootSize.us) {
        result = getBootSize2.us;
        const smaller = Math.min(getBootSize.us, getBootSize2.us);
        const larger = Math.max(getBootSize.us, getBootSize2.us);
        if (fullDown) {
          result = smaller - 0.5;
        } else if (halfDown || ttsSmaller) {
          result = smaller;
        } else if (halfUp || ttsLarger) {
          result = larger;
        } else if (fullUp) {
          result = larger + 0.5;
        }
      } else {
        result = getBootSize.us;
        if (fullDown) {
          result = getBootSize.us - 0.5;
        } else if (halfDown || ttsSmaller || ttsLarger || halfUp) {
          result = getBootSize.us;
        } else if (fullUp) {
          result = getBootSize.us + 0.5;
        }
      }
    }

    let width = 'Standard';

    if (getHasWidth === true) {
      if (getWidth === 'Wide' || getWidth === 'EE' || getWidth === 'EEE') {
        if (hasWideWidth) {
          width = 'Wide';
        } else {
          result += 0.5;
        }
      } else if (getWidth === 'Narrow' || getWidth === 'B' || getWidth === 'C') {
        result -= 0.5;
      }
    }

    if (isWomens && getStandard.code === 'mens') {
      result += 1.5;
    } else if (!isWomens && getStandard.code === 'womens') {
      result -= 1.5;
    }

    if (result) {
      setRecommendedSize(result);
      setRecommendedWidth(width);
    }
  }

  const Counter = () => {
    if (step > 4) {
      return (<p className="counter">Result</p>);
    }
    if (isSneaker && step === 4) {
      return (<p className="counter">Step 3 <span className="counter-subtext">of {screenCount}</span></p>)
    }
    return (<p className="counter">Step {step} <span className="counter-subtext">of {screenCount}</span></p>)
  }

  const Footer = () => {
    if (step > 4) {
      return (
        <div className="form-footer form-footer-column">
          <AddToCartButton recommendedVariant={recommendedVariant} product={props.product} _optionChanged={props._optionChanged} closeFitFinder={props.closeFitFinder} />
          <button className="form-footer-button action-button back-button start-over-button" type="button" onClick={() => resetForm()}>
            <SVG icon="arrow-thin-left" />
            Start Over
          </button>
        </div>
      )
    } else if (step === 1) {
      return (
        <div className="form-footer">
          <button disabled={!validForm} className={validForm ? "form-footer-button action-button" : "form-footer-button action-button button-disabled"} type="button" onClick={() => advanceToStep2()}>
            Next Question
            <SVG icon="arrow-thin-right" />
          </button>
        </div>
      )
    }
    return (
      <div className="form-footer">
        <button className="form-footer-button action-button back-button" type="button" onClick={() => goBack()}>
          <SVG icon="arrow-thin-left" />
          Back
        </button>
        <button disabled={!validForm} className={validForm ? "form-footer-button action-button" : "form-footer-button action-button button-disabled"} type="button" onClick={() => advanceForm()}>
          Next Question
          <SVG icon="arrow-thin-right" />
        </button>
      </div>
    );
  }

  return (
    <div id="fit-finder" className="ff-wrap">
      <div className="ff-header">
        <img src="https://cdn.shopify.com/s/files/1/0419/1525/files/ruler-icon.svg?10153809238683260143" className="sizing-ruler" />
        <h1 className="title">
          Find your size
        </h1>
        <div className="form-counter">
          <Counter />
        </div>
        <progress className="ff-progress" value={step} max={screenCount}></progress>
      </div>

      <div className={step === 5 ? "ff-form ff-result" : "ff-form"}>
        {step === 1 && <Step1 locations={locations} setLocation={setLocation} getLocation={getLocation} standards={standards} setStandard={setStandard} getStandard={getStandard} step={step} setStep={setStep} _openSizeGuide={props._openSizeGuide} closeFitFinder={props.closeFitFinder} />}
        {step === 2 && <Step2 sizes={sizes} getLocation={getLocation} getStandard={getStandard} getSneakerSize={getSneakerSize} setSneakerSize={setSneakerSize} getSneakerSize2={getSneakerSize2} setSneakerSize2={setSneakerSize2} step={step} setStep={setStep} isWomens={isWomens} isSneaker={isSneaker} />}
        {step === 3 && <Step3 sizes={sizes} getLocation={getLocation} getStandard={getStandard} getHasBootSize={getHasBootSize} setHasBootSize={setHasBootSize} getBootSize={getBootSize} setBootSize={setBootSize} getBootSize2={getBootSize2} setBootSize2={setBootSize2} step={step} setStep={setStep} product={props.product} isWomens={isWomens} isSneaker={isSneaker} />}
        {step === 4 && <Step4 widths={widths} getLocation={getLocation} getStandard={getStandard} getHasWidth={getHasWidth} setHasWidth={setHasWidth} getWidth={getWidth} setWidth={setWidth} step={step} setStep={setStep} />}
        {step === 5 && <Result product={props.product} recommendedSize={recommendedSize} recommendedWidth={recommendedWidth} hasWideWidth={hasWideWidth} recommendedVariant={recommendedVariant} setRecommendedVariant={setRecommendedVariant} />}
      </div>
      <Footer />
    </div>
  )
}